export const fontFamily = {
  primary: 'var(--font-geist), "Geist Variable", system-ui',
  accent: {
    fontFamily:
      'var(--font-retail), "retail-variable", "Bricolage Grotesque Variable", system-ui',
    fontVariationSettings: '"opsz" 700',
  },
  serif: 'var(--font-lora), "Lora Variable", system-ui',
  mono: '"Geist Mono", "JetBrains Mono", "IBM Plex Mono", Monaco, Consolas, monospace',
} as const
export type Fonts = keyof typeof fontFamily
